import React, { Children } from 'react';
import { motion } from 'framer-motion';
// Custom Star SVG
const StarIcon = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="currentColor" className={className} data-id="element-361">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" data-id="element-362" />
  </svg>;
// Custom Quote SVG
const QuoteIcon = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="currentColor" className={className} data-id="element-363">
    <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h4v10h-10z" data-id="element-364" />
  </svg>;
export function SocialProofSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="py-20 bg-brand-dark relative border-t border-white/5" data-id="element-365">
      <div className="container mx-auto px-6 md:px-12" data-id="element-366">
        {/* Stats Bar */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} variants={containerVariants} className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-20 pb-16 border-b border-white/10" data-id="element-367">
          <motion.div variants={itemVariants} className="text-center" data-id="element-368">
            <div className="font-heading text-4xl md:text-5xl font-bold text-brand-yellow mb-2" data-id="element-369">
              +500
            </div>
            <div className="text-sm md:text-base text-brand-gray uppercase tracking-wider font-medium" data-id="element-370">
              Negocios Atendidos
            </div>
          </motion.div>
          <motion.div variants={itemVariants} className="text-center" data-id="element-371">
            <div className="font-heading text-4xl md:text-5xl font-bold text-brand-yellow mb-2" data-id="element-372">
              $3.2M+
            </div>
            <div className="text-sm md:text-base text-brand-gray uppercase tracking-wider font-medium" data-id="element-373">
              Revenue Generado
            </div>
          </motion.div>
          <motion.div variants={itemVariants} className="text-center" data-id="element-374">
            <div className="font-heading text-4xl md:text-5xl font-bold text-brand-yellow mb-2" data-id="element-375">
              +15,000
            </div>
            <div className="text-sm md:text-base text-brand-gray uppercase tracking-wider font-medium" data-id="element-376">
              Leads Entregados
            </div>
          </motion.div>
          <motion.div variants={itemVariants} className="text-center" data-id="element-377">
            <div className="font-heading text-4xl md:text-5xl font-bold text-brand-yellow mb-2" data-id="element-378">
              98%
            </div>
            <div className="text-sm md:text-base text-brand-gray uppercase tracking-wider font-medium" data-id="element-379">
              Tasa de Satisfacción
            </div>
          </motion.div>
        </motion.div>

        {/* Testimonials */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} variants={containerVariants} className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-380">
          {/* Testimonial 1 */}
          <motion.div variants={itemVariants} className="bg-brand-black border border-white/5 p-8 rounded-xl relative" data-id="element-381">
            <QuoteIcon className="w-10 h-10 text-brand-yellow/20 absolute top-6 right-6" data-id="element-382" />
            <div className="flex space-x-1 mb-6" data-id="element-383">
              {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-5 h-5 text-brand-yellow" data-id="element-384" />)}
            </div>
            <p className="text-lg text-white leading-relaxed mb-8 italic" data-id="element-385">
              "Antes de Doctor Ecommerce, hacía 3 trabajos por semana. Ahora
              tengo la agenda llena con contratos comerciales de $2,000+. En 60
              días triplicamos las llamadas."
            </p>
            <div className="flex items-center" data-id="element-386">
              <div className="w-12 h-12 bg-brand-darker rounded-full flex items-center justify-center border border-brand-yellow/30 mr-4" data-id="element-387">
                <span className="font-heading font-bold text-brand-yellow" data-id="element-388">
                  CM
                </span>
              </div>
              <div data-id="element-389">
                <h4 className="font-bold text-white" data-id="element-390">Carlos M.</h4>
                <p className="text-sm text-brand-gray" data-id="element-391">
                  Pest Control Pro, Miami FL
                </p>
              </div>
            </div>
          </motion.div>

          {/* Testimonial 2 */}
          <motion.div variants={itemVariants} className="bg-brand-black border border-white/5 p-8 rounded-xl relative" data-id="element-392">
            <QuoteIcon className="w-10 h-10 text-brand-yellow/20 absolute top-6 right-6" data-id="element-393" />
            <div className="flex space-x-1 mb-6" data-id="element-394">
              {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-5 h-5 text-brand-yellow" data-id="element-395" />)}
            </div>
            <p className="text-lg text-white leading-relaxed mb-8 italic" data-id="element-396">
              "Pensé que el marketing digital no funcionaba para fumigación. Me
              equivoqué. Los leads que llegan son de termitas y roedores — los
              trabajos grandes que necesitaba."
            </p>
            <div className="flex items-center" data-id="element-397">
              <div className="w-12 h-12 bg-brand-darker rounded-full flex items-center justify-center border border-brand-yellow/30 mr-4" data-id="element-398">
                <span className="font-heading font-bold text-brand-yellow" data-id="element-399">
                  RS
                </span>
              </div>
              <div data-id="element-400">
                <h4 className="font-bold text-white" data-id="element-401">Roberto S.</h4>
                <p className="text-sm text-brand-gray" data-id="element-402">
                  Bug Shield Services, Houston TX
                </p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}